import { GET_GOV_HOME_SERVICES } from '../../constants/ActionTypes';

export function getGovHomeServices() {
  return {
    type: GET_GOV_HOME_SERVICES,
    request: {
      op: 'get',
      path: '/@govbr-services',
    },
  };
}
